import React, { useContext } from 'react';
import { Box, Button } from '@mui/material';
import Modal from '@mui/material/Modal';
import './AlertBox.css';
// import { useNavigate } from 'react-router-dom';
import { CommonContext } from '../../context/CommonContext';

const AlertBox = () => {
  //   const navigate = useNavigate();
  const { alertState, setAlertState } = useContext(CommonContext);

  const handleClose = () => {
    // Execute onClose callback if provided
    if (alertState?.onClose && typeof alertState?.onClose === 'function') {
      alertState.onClose();
    }

    // Close the alert
    setAlertState({
      open: false,
      title: '',
      message: '',
      btnTxt: 'OK',
      status: 'success',
      type: 'alert',
      onClose: null,
      onConfirm: null
    });
  };

  const handleConfirm = () => {
    // Execute onConfirm callback if provided
    if (alertState?.onConfirm && typeof alertState?.onConfirm === 'function') {
      alertState.onConfirm();
    }

    // Close the alert
    setAlertState({
      open: false,
      title: '',
      message: '',
      btnTxt: 'OK',
      status: 'success',
      type: 'alert',
      onClose: null,
      onConfirm: null
    });
  };

  const btnClass = `alert-${alertState?.status}--button`;
  const isConfirmDialog = alertState?.type === 'confirm';

  return (
    <Modal
      open={alertState?.open}
      className="customModal"
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="alert-fail">
        <Box className="alert-fail--box">
          <div className="alert-fail--header">
            <h2>Message Box</h2>
          </div>

          {/* Alert message - handles both string and array */}
          <div className="alert-fail--message">
            <p>
              {Array.isArray(alertState?.title) ? (
                alertState?.title.map((error, index) => (
                  <React.Fragment key={index}>
                    <span>{error}</span>
                    <br />
                  </React.Fragment>
                ))
              ) : (
                alertState?.title
              )}
            </p>
            {/* Show additional message if provided */}
            {alertState?.message && (
              <p className="alert-fail--submessage">{alertState?.message}</p>
            )}
          </div>

          {/* Action button */}
          <div className={"alert-fail--button"}>
            {isConfirmDialog ? (
              <>
                {/* Cancel/No button */}
                <Button
                  variant="outlined"
                  onClick={handleClose}
                  style={{ marginRight: '10px' }}
                >
                  {alertState?.cancelBtnTxt || 'No'}
                </Button>
                {/* Confirm/Yes button */}
                <Button
                  variant="contained"
                  onClick={handleConfirm}
                >
                  {alertState?.btnTxt || 'Yes'}
                </Button>
              </>
            ) : (
              <Button variant="contained" onClick={handleClose}>
                {alertState?.btnTxt}
              </Button>
            )}
          </div>
        </Box>
      </div>
    </Modal>
  );
};

export default AlertBox;